import { initializeApp } from "firebase/app";
import { getAnalytics, isSupported as analyticsIsSupported } from "firebase/analytics";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyCpLDNhJ6_bt_H7ZypCYscC4eD_1Z4JGP4",
  authDomain: "campus-market-bca64.firebaseapp.com",
  projectId: "campus-market-bca64",
  storageBucket: "campus-market-bca64.firebasestorage.app",
  messagingSenderId: "391583629825",
  appId: "1:391583629825:web:d14505eb259961c8ca3600",
  measurementId: "G-E67BJ7S1WN"
};

export const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

let analytics: ReturnType<typeof getAnalytics> | null = null;
(async () => {
  // Initialize Analytics only when supported (browser environments)
  try {
    if (typeof window !== "undefined" && await analyticsIsSupported()) {
      analytics = getAnalytics(app);
    }
  } catch (e) {
    // ignore analytics errors; core app should still run
  }
})();

export { analytics };